"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var React = require("react");
var _1 = require(".");
var _Core_1 = require("../../_Core");
var Icon_1 = require("../../Icons/Icon/Icon");
var Dropdown_styles_1 = require("./Dropdown.styles");
exports.Dropdown = React.memo(function (_a) {
    var _b = _a.Appearance, Appearance = _b === void 0 ? "Standard" : _b, AriaLabel = _a.AriaLabel, Disabled = _a.Disabled, DropdownListItems = _a.DropdownListItems, HasErrors = _a.HasErrors, HideBorder = _a.HideBorder, ID = _a.ID, OnChange = _a.OnChange, Value = _a.Value, Width = _a.Width;
    var buildStyle = function () {
        var style = HideBorder ? Dropdown_styles_1.DropdownSelectorOverrideDiv : {};
        if (Width) {
            style.width = Width;
        }
        return style;
    };
    var getCaption = function (value) {
        if (value !== undefined && DropdownListItems && DropdownListItems.length > 0) {
            var possibleCaptions = DropdownListItems.filter(function (item) {
                // double equals instead of triple here because we compare our DropdownListItems values, which can be a string or a number,
                // and an event target on a select box, which is always a string
                // tslint:disable-next-line: triple-equals
                if ("" + item.Value === "" + value) {
                    return item;
                }
            });
            if (possibleCaptions && possibleCaptions.length > 0) {
                return possibleCaptions[0].Caption;
            }
        }
        return undefined;
    };
    var handleSelect = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var value, caption, selectedObject, onChangeVal, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    value = e.target.value;
                    caption = getCaption(value);
                    selectedObject = {
                        Caption: caption,
                        Value: value,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    onChangeVal = OnChange(selectedObject);
                    if (!(onChangeVal instanceof Promise)) return [3 /*break*/, 3];
                    return [4 /*yield*/, onChangeVal];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    if (error_1 !== _1.dropdownMessageCancelError) {
                        throw error_1;
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Dropdown_styles_1.DropdownSelectorDiv, { Appearance: Appearance, HasErrors: HasErrors, style: buildStyle(), "aria-disabled": Disabled },
        React.createElement(Dropdown_styles_1.DropdownInnerWrapperDiv, null,
            React.createElement(Dropdown_styles_1.CaptionDiv, null, getCaption(Value)),
            React.createElement(Dropdown_styles_1.DropdownIconDiv, null,
                React.createElement(Icon_1.Icon, { Icon: _Core_1.Icons.CaretDown, Height: "24px", Width: "24px" }))),
        React.createElement(Dropdown_styles_1.DropdownSelect, { id: ID, disabled: Disabled, onChange: function (e) { return handleSelect(e); }, value: Value, "aria-label": AriaLabel }, DropdownListItems
            ? DropdownListItems.map(function (item, index) { return React.createElement("option", { selected: "" + item.Value === "" + Value, key: item.Value, value: item.Value, disabled: item.Disabled }, item.Caption); })
            : undefined)));
});
